import OrganisationForm from "./OrganisationForm";
import back_arrow from "../../assets/backarrow.svg"

const NewOrganisation = (props) => {

    const updateOrganisationsGrid = props.updateOrganisationsGrid

    return (
        <>
            <div className="back-link link" onClick={() => updateOrganisationsGrid()}>
                <img className={"back-arrow-classname"} src={back_arrow} alt={"Back Arrow"}/>
            </div>
            <div className="organisations-page-header">
                <div className="organisations-page-title">New Organisation</div>
            </div>
            <OrganisationForm updateData={updateOrganisationsGrid.bind(this)} buttonText={"Save and continue"}/>
        </>
    )
}
export default NewOrganisation;